import { senseiCredentials } from '../data/content';
import useReveal from '../hooks/useReveal';
import senseiImg from '../assets/sensei.jpg';
import './Sensei.css';

export default function Sensei() {
  const photoRef = useReveal();
  const textRef = useReveal();

  return (
    <section id="sensei" className="sensei">
      <div className="sensei__kanji-bg">先生</div>
      <div className="sensei__inner">
        <div className="sensei__header">
          <div className="sensei__eyebrow">Dirección Técnica</div>
          <h2 className="sensei__title">
            SENSEI <span className="text-red">CRISTHIAN TORO</span>
          </h2>
          <div className="sensei__jp">クリスティアン・トロ</div>
        </div>

        <div className="sensei__grid">
          <div ref={photoRef} className="sensei__photo-wrap reveal">
            <div className="sensei__corner sensei__corner--tl" />
            <div className="sensei__corner sensei__corner--br" />
            <div className="sensei__photo pin-dark">
              <img
                src={senseiImg}
                alt="Sensei Cristhian Toro"
                className="sensei__photo-img"
              />
              <div className="sensei__photo-caption">
                <span>Fundador · Director Técnico</span>
              </div>
            </div>
          </div>

          <div ref={textRef} className="sensei__content reveal">
            <h3 className="sensei__heading">Liderazgo y Experiencia</h3>
            <p className="sensei__text sensei__text--lead serif">
              El Sensei Cristhian Toro es el fundador y director técnico del
              Centro de Entrenamiento Kamae. Con años de dedicación al Karate Do
              Shito Ryu, ha formado a numerosos practicantes en el camino del
              guerrero.
            </p>
            <p className="sensei__text">
              Como examinador oficial de la Federación Colombiana de Karate
              Do, garantiza la calidad técnica y el cumplimiento de los
              estándares internacionales.
            </p>

            <div className="sensei__credentials">
              {senseiCredentials.map((c) => (
                <div
                  key={c.title}
                  className={`sensei__credential${
                    c.wide ? ' sensei__credential--wide' : ''
                  }`}
                >
                  <div className="sensei__credential-title">{c.title}</div>
                  <div className="sensei__credential-subtitle">
                    {c.subtitle}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}